var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F6F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4665 24C41.379 24.4308 41.3332 24.8767 41.3332 25.3333C41.3332 25.79 41.379 26.2358 41.4665 26.6667H26.0151L36.0824 35.5493L42.8129 29.5219C43.3816 30.2252 44.0904 30.8105 44.8969 31.2354L36.0956 39.1173L25.3332 29.6212V45.3333H46.6665V31.8666C47.0973 31.9541 47.5432 32 47.9998 32C48.4565 32 48.9024 31.9541 49.3332 31.8666V46.6667C49.3332 47.4031 48.7362 48 47.9998 48H23.9998C23.2635 48 22.6665 47.4031 22.6665 46.6667V25.3333C22.6665 24.597 23.2635 24 23.9998 24H41.4665ZM47.9998 21.3333C50.209 21.3333 51.9998 23.1242 51.9998 25.3333C51.9998 27.5425 50.209 29.3333 47.9998 29.3333C45.7906 29.3333 43.9998 27.5425 43.9998 25.3333C43.9998 23.1242 45.7906 21.3333 47.9998 21.3333Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyAccount);
export default __webpack_public_path__ + "static/media/verify-account.0e071e5e0eb9fb1013096516bb3650df.svg";
export { ForwardRef as ReactComponent };